import { Link } from "react-router-dom";
import {
  MdDashboard,
  MdDescription,
  MdOutlineImage,
  MdOutlineAirplay,
  MdSettings,
  MdSupervisorAccount,
} from "react-icons/md";
import Head from "../../Components/Head";
import styleDashboard from "./Dashboard.module.css";

const QUICK_LINKS = [
  {
    title: "Scenes",
    description: "Manage immersive scenes and deployments.",
    to: "/web-twinprocms/scene",
    icon: MdOutlineImage,
  },
  {
    title: "Unity Scenes",
    description: "WebGL scene assets and builds.",
    to: "/web-twinprocms/unity-scene",
    icon: MdOutlineAirplay,
  },
  {
    title: "File Library",
    description: "Upload and organize media files.",
    to: "/web-twinprocms/file-library",
    icon: MdDescription,
  },
  {
    title: "Products",
    description: "Product catalog and related content.",
    to: "/web-twinprocms/products",
    icon: MdDashboard,
  },
  {
    title: "Users",
    description: "Team members, roles, and access.",
    to: "/web-twinprocms/users",
    icon: MdSupervisorAccount,
  },
  {
    title: "Settings",
    description: "Site configuration and branding.",
    to: "/web-twinprocms/basic-settings",
    icon: MdSettings,
  },
];

const Dashboard = () => {
  const brand = process.env.REACT_APP_BRAND || "Web-Twin";

  return (
    <>
      <Head title="Dashboard" />
      <div className={styleDashboard.dashboardPage}>
        <div className={styleDashboard.hero}>
          <h1 className={styleDashboard.welcome}>
            {/* Welcome to {brand} CMS */}
            Welcome to CMS
          </h1>
          <p className={styleDashboard.subtitle}>
            Pick a section below to manage your spaces, content, and platform settings.
          </p>
        </div>

        <div className={styleDashboard.quickGrid}>
          {QUICK_LINKS.map(item => {
            const Icon = item.icon;
            return (
              <Link key={item.to} to={item.to} className={styleDashboard.quickCard}>
                <span className={styleDashboard.quickIcon} aria-hidden="true">
                  <Icon size={22} />
                </span>
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Dashboard;
